export const VERIFY_USER_SUCCESS = 'VERIFY_USER_SUCCESS'
export const VERIFY_USER_FAILURE = 'VERIFY_USER_FAILURE'

export const HAS_READ_USER_ERROR = 'HAS_READ_USER_ERROR'

export const ADD_TODO_SUCCESS = 'ADD_TODO_SUCCESS'
export const ADD_TODO_FAILURE = 'ADD_TODO_FAILURE'

export const UPDATE_TODO_SUCCESS = 'UPDATE_TODO_SUCCESS'
export const UPDATE_TODO_FAILURE = 'UPDATE_TODO_FAILURE'

export const COMPLETED_TODO_SUCCESS = 'COMPLETED_TODO_SUCCESS'
export const COMPLETED_TODO_FAILURE = 'COMPLETED_TODO_FAILURE'

export const FETCH_TODOS_SUCCESS = 'FETCH_TODOS_SUCCESS'
export const FETCH_TODOS_FAILURE = 'FETCH_TODOS_FAILURE'

export const TOGGLE_EDIT_ID = 'TOGGLE_EDIT_ID'
export const CHANGE_NEW_TODO_DESCRIPTION = 'CHANGE_NEW_TODO_DESCRIPTION'

export const CHANGE_NEW_TOMATO_DESCRIPTION = 'CHANGE_NEW_TOMATO_DESCRIPTION'

export const FETCH_TOMATOES_SUCCESS = 'FETCH_TOMATOES_SUCCESS'
export const FETCH_TOMATOES_FAILURE= 'FETCH_TOMATOES_FAILURE'

export const ADD_TOMATO_SUCCESS = 'ADD_TOMATO_SUCCESS'
export const ADD_TOMATO_FAILURE = 'ADD_TOMATO_FAILURE'

export const UPDATE_TOMATO_SUCCESS = 'UPDATE_TOMATO_SUCCESS'
export const UPDATE_TOMATO_FAILURE = 'UPDATE_TOMATO_FAILURE'



// WEBPACK FOOTER //
// ./src/store/constants.ts